export default __webpack_public_path__ + "static/media/teamworkIcon.3d99bd15.png";